export enum PartialEarlySettlementViewType {
    CALCULATIONS = 'PES_CALCULATIONS',
    QUOTE_DETAILS = 'PES_QUOTE_DETAILS',
    OFFLINE_PAYMENT = 'PES_OFFLINE_PAYMENT',
}
